/* Homepage reviews carousel: drop reviews that name a retired product.
 *
 * The carousel pool still contains reviews written for the V1 line, whose
 * product names ("Daily // Baseline Hydration", "Perform", "The System")
 * no longer exist. The product attribution is hidden in CSS, but a review
 * whose own words name one of those products would still confuse a reader,
 * so those are removed here.
 *
 * Judge.me builds the carousel asynchronously and can re-render it, so this
 * runs on every subtree change rather than once on load. Matched items are
 * removed from the DOM rather than hidden, so the slider does not advance
 * onto an empty slide.
 *
 * The word list is deliberately narrow. Widening it is cheap; every term
 * added also removes genuine reviews that happen to use the word.
 */
(function () {
  var RETIRED_PRODUCT_WORDS = /\b(perform|daily)\b/i;

  function reviewText(item) {
    var parts = [];
    var content = item.querySelector('.jdgm-carousel-item__review-content');
    var title = item.querySelector('.jdgm-carousel-item__review-title');
    if (title) parts.push(title.textContent || '');
    if (content) parts.push(content.textContent || '');
    if (!parts.length) parts.push(item.textContent || '');
    return parts.join(' ');
  }

  function prune(root) {
    var items = root.querySelectorAll('.jdgm-carousel-item');
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (item.hasAttribute('data-src-checked')) continue;
      item.setAttribute('data-src-checked', '');
      if (RETIRED_PRODUCT_WORDS.test(reviewText(item))) {
        var slide = item.closest('.jdgm-carousel__item-wrapper') || item;
        // Only unwrap the slide when it holds this review alone.
        if (slide !== item && slide.querySelectorAll('.jdgm-carousel-item').length > 1) {
          item.remove();
        } else {
          slide.remove();
        }
      }
    }
  }

  /* Equal-height cards.
   *
   * The slides are inline-block and size to their own content, so a short
   * review leaves a visibly shorter card. Judge.me equalises them itself, but
   * only by measuring with the product attribution still in place, which we
   * hide — so that measurement is released in CSS and redone here instead.
   *
   * Measured rather than a fixed min-height in CSS, because the right height
   * depends on how the text wraps at the current card width. Reset first so
   * shrinking back down works, then apply the tallest.
   *
   * Writing style.minHeight only changes an attribute, and the observer below
   * watches childList, so this cannot re-trigger itself.
   */
  function equalize(root) {
    var items = root.querySelectorAll('.jdgm-carousel-item');
    if (!items.length) return;
    var i;
    for (i = 0; i < items.length; i++) items[i].style.minHeight = '';
    var tallest = 0;
    for (i = 0; i < items.length; i++) {
      tallest = Math.max(tallest, items[i].getBoundingClientRect().height);
    }
    if (!tallest) return;
    for (i = 0; i < items.length; i++) {
      items[i].style.minHeight = Math.ceil(tallest) + 'px';
    }
  }

  function start() {
    var root = document.querySelector('.src-revcar');
    if (!root) return;

    var queued = false;
    function refresh() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        prune(root);
        equalize(root);
      });
    }

    refresh();
    new MutationObserver(refresh).observe(root, { childList: true, subtree: true });
    // Card width drives how the text wraps, so heights must be remeasured.
    window.addEventListener('resize', refresh);
    // Late-loading webfonts reflow the text after the first measurement.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(refresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
